export type WheelType = {
  id?: string;
  checked?: boolean;
  manufacturer?: string;
  tireWidth?: string;
  aspectRatio?: string;
  rim?: string;
  tread?: number;
  rimType?: string;
  season?: string;
  li?: string;
  sr?: string;
  dot?: string;
  location: string;
  title?: string;
  note?: string;
};
